<template>
	<div class="page-in">
		<van-nav-bar
		  :title="$t('确认订单')"
		  fixed
		  placeholder
		  left-arrow
		  z-index="99"
		  @click-left="back"
		  :border="false"
		  v-if="isMobileFlag"
		/>
		<div class="inside-page">
			<div class="m-container" v-if="isMobileFlag">
				<div class="panel-m-select">
					<div class="m-select-card" @click="showAddress">
						<div class="iconfont icon-address"></div>
						<div class="flex-col">
							<div class="m-card-title">{{defaultAddress.content}}</div>
							<div class="m-card-desc">
								<div>{{defaultAddress.name}}</div>
								<div>{{defaultAddress.tel}}</div>
							</div>
						</div>
						<div class="iconfont icon-l-right"></div>
					</div>
				</div>
				<div class="pay-m-select">
					<div class="m-pay-cell" @click="showWallet">
						<div class="iconfont icon-qianbao"></div>
						<div class="flex-col">
							<div class="m-card-title">{{defaultWallet.title}}</div>
						</div>
						<div class="iconfont icon-l-right"></div>
					</div>
				</div>
				<div class="m-goods">
					<div class="m-goods-cell" v-for="(item,index) in details" :key="index">
						<div class="m-goods-row">
							<div class="m-photo">
								<img :src="item.pic" alt="" />
							</div>
							<div class="flex-col">
								<div class="m-goods-title ellipsis">{{item.title}}</div>
								<div class="m-goods-item ">
									{{$t('主要版本')}}：{{item.item}}
								</div>
								<div class="m-goods-item ">
									<span class="item">{{$t('主要版本')}}大小：{{item.size}}</span>
									<span class="item-price text-primary">{{item.price}} VND</span>
								</div>
							</div>
						</div>
						<div class="input-number-row">
							<div class="layui-input-number">
								<el-input-number size="small" v-model="item.counter" :min="1" :max="99"></el-input-number>
							</div>
						</div>
					</div>
				</div>
				<div class="confir-foot">
					<el-form ref="form" label-position="left" :model="form" label-width="110px">
					  <el-form-item label="选择使用抵扣券">
						<el-select v-model="form.coupon" placeholder="请选择活动区域">
						  <el-option label="500,000WND 抵扣券" value="500,000"></el-option>
						  <el-option label="600,000WND 抵扣券" value="600,000"></el-option>
						</el-select>
					  </el-form-item>
					</el-form>
				</div>
				<div class="order-tabber">
					<div class="flex-col">
						<div class="totaol-price">
							共1件商品 抵扣券减免 <span class="text-primary">50,000.00</span>
						</div>
						<div class="totaol-price text-primary">
							合计<span class="price-v">13,443,1000.00 VND</span>
						</div>
					</div>
					<el-button type="primary">立即购买</el-button>
				</div>
			</div>
			<!-- pc -->
			<div class="layui-container" v-else>
				<div class="brread-box">
					<el-breadcrumb separator="/">
					  <el-breadcrumb-item :to="{ path: '/cart' }">{{$t('购物车')}}</el-breadcrumb-item>
					  <el-breadcrumb-item>{{$t('确认订单信息')}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="confirm-panel">
					<div class="confirm-panel_hd">
						<div class="tt">{{$t('选择收货地址')}}</div>
						<el-link type="info" @click="goUrl('/address')">{{$t('管理收货地址')}}</el-link>
					</div>
					<div class="panel-select" v-if="addressData.length > 0">
						<div class="panel-select-card" v-for="(item, index) in addressData"
						  :key="index"
						  :class="{ on: index == addressCur }"
						  @click="addressSelect(index,item.id)">
							<div class="s-card-title">{{item.detail}}</div>
							<div class="s-card-desc">
								<div>{{item.name}}</div>
								<div>{{item.phone}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="confirm-panel" >
					<div class="confirm-panel_hd">
						<div class="tt">确认订单信息</div>
					</div>
					<table class="bs-table ">
					  <colgroup>
						<col width="36%">
						<col>
					  </colgroup>
					  <tbody>
						<tr>
						  <th>{{$t('商品名称')}}</th>
						  <th>{{$t('商品属性')}}</th>
						  <th>{{$t('单价')}}</th>
						  <th>{{$t('数量')}}</th>
						  <th>{{$t('实付款')}}</th>
						</tr>
						<tr v-for="(item,index) in orderProduct" :key="index">
						  <td>
							  <div class="td-goods">
								  <div class="td-goods-photo"><img :src="item.image" alt="" /></div>
								  <div class="flex-col">
									  <div class="td-goods-title">
										  {{$t(item.title)}}
									  </div>
								  </div>
							  </div>
						  </td>
						  <td>
							  <div>规格：{{item.sku}}</div>
						  </td>
						  <td>{{item.price}} {{$t('VND')}}</td>
						  <td>
							  {{item.num}}
						  </td>
						  <td>{{formatNumber(item.price * item.num)}} {{$t('VND')}}</td>
						</tr>
						<tr>
							<td colspan="5">
								<div class="totaol-price text-primary">
									合计<span class="price-v">{{ formatNumber(totalPrice) }} {{$t('VND')}}</span>
								</div>
							</td>
						</tr>
					  </tbody>
					</table>
				</div>
				<div class="confirm-panel">
					<div class="confirm-panel_hd">
						<div class="tt">选择支付方式</div>
					</div>
					<div class="panel-select">
						<div class="panel-select-card" v-for="(item, index) in wallet"
						  :key="index"
						  :class="{ on: index == walletCur }"
						  @click="walletSelect(index)">
							<div class="s-card-title">{{item.title}}</div>
							<div class="s-card-balance">
								<div>余额</div>
								<div>123,123,123.00</div>
							</div>
						</div>
					</div>
				</div>
				<div class="confirm-panel-foot">
					<el-button type="warning" class="btn-submit" round @click="goOrderAdd">提交订单</el-button>
				</div>
			</div>
		</div>
		<selectAddress ref="selectAddress"></selectAddress>
		<selectPayType ref="selectPayType"></selectPayType>
	</div>
</template>
<script>
	import helper from '@/common/helper.js';
	import {
		order_add_api,
		address_api
	} from "@/api/user"
	import selectPayType from './components/selectPayType'
	import selectAddress from './components/selectAddress'
	export default {
		components:{
			selectAddress,
			selectPayType,
		},
		data() {
			return {
				form:{
					coupon:'',
				},
				addressData:[],
				addressCur: 0,
				wallet: [
					{ title: "钱包余额支付",isdefault:true },
					{ title: "钱包余额支付",isdefault:false}
				],
				walletCur: 0,
				
				orderProduct:[],
				goods:'',
				address_id:0,
				notes:'',
				
			};
		},
		computed: {
			totalPrice() {
			    return this.orderProduct.reduce((total, item) => {
			      return total + (item.price * item.num);
			    }, 0);
			  },
		    defaultAddress() {
		      // 查找 isdefault 为 true 的地址
		      const defaultAddr = this.addressData.find(addr => addr.isdefault);
		      return defaultAddr || this.addressData[0] || null;
		    },
			defaultWallet() {
		      // 查找 isdefault 为 true 的地址
		      const defaultWallet = this.wallet.find(item => item.isdefault);
		      return defaultWallet || this.wallet[0] || null;
		    }
		  },
		methods: {
			addressSelect(index,address_id){
			  this.addressCur = index;
			  this.address_id = address_id;
			},
			changeTab(index){
			  this.curTab = index;
			},
			showAddress(){
				this.$refs.selectAddress.show = true
			},
			showWallet(){
				this.$refs.selectPayType.show = true
			},
			async getAddress() {
				await address_api().then(res => {
					if (res && res.data.code == 1) {
						this.addressData = res.data.data.list
						this.address_id = this.addressData[0].id
					}
				});
			},
			async goOrderAdd() {
				let param = {
					goods:JSON.stringify(this.orderProduct),
					address_id:this.address_id,
					notes:'ceshi',
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_add_api(param).then(res => {
					console.log(res.data)
					if (res && res.data.code == 1) {
						
					}
					loading.close()
				});
			},
		},
		mounted() {
			this.getAddress()
			this.orderProduct = helper.get('ConfirmProductData') || []
			console.log(this.orderProduct,'this.orderProduct')
		}	
	};
</script>
<style scoped>
	.confir-foot{
		display: flex;
		justify-content: space-between;
		text-align: right;
	}
	.confir-item:first-child{
		margin-bottom: 10px;
	}
	.td-goods{
		display: flex;
	}
	.td-goods-photo{
		font-size: 0;
		margin-right: 20px;
	}
	.td-goods-photo img{
		width: 100px;
		height: 100px;
	}
	.td-goods .flex-col{
		padding: 20px 0;
	}
	.m-select-card{
		padding: 10px;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border: 1px dashed #8B6E35;
		.m-card-title{
			margin-bottom: 5px;
		}
		.m-card-desc{
			display: flex;
			font-size: 12px;
			color: #909090;
			div{
				margin-right: 10px;
			}
		}
		.icon-address{
			font-size: 20px;
			margin-right: 10px;
		}
	}
	
	
	.m-pay-cell{
		display: flex;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #909090;
		.icon-qianbao{
			margin-right: 10px;
			font-size: 20px;
		}
	}
	.order-tabber{
		position: fixed;
		height: 60px;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 99;
		display: flex;
		align-items: center;
		padding: 0 15px;
		background: #FFFFFF;
		font-size: 13px;
		box-shadow: 0px 1px 38px 0px rgba(113,53,0,0.11);
		.el-button{
			border-radius: 30px;
		}
	}
	
	.m-goods-cell{
		padding: 20px 0;
		border-bottom: 1px solid #909090;
	}
	.m-goods-row{
		display: flex;
		align-items: center;
	}
	.m-goods-row .m-photo{
		margin-right: 10px;
		img{
			width: 60px;
			height: 60px;
		}
	}
	.m-goods-item {
		font-size: 13px;
		display: flex;
		.item-price{
			margin-left: auto;
		}
	}
	.m-goods-title{
		font-size: 16px;
	}
	
	.input-number-row{
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
	}
	.m-goods{
		margin-bottom: 20px;
	}
	
	
	
	
	
	
</style>















